class FileUtil {
  static urlHasExtension(url: string): boolean {
    return /\.\w+$/.test(url);
  }
}

export default FileUtil;
